module.exports = __webpack_public_path__ + "static/media/GPS_Logo.8845876f.png";